import { useState, useEffect, useContext } from "react";
import {
  APIs,
  API_BASE_URL,
  REPORTDONESTATUS,
  SHARED_VIEWER,
  NonAuthRoutes,
} from "../../constants/Constants";
import {
  downloadPdfReport,
  getPatientReportData,
  getReportTemplatesData,
} from "../../service/StudyReportService";
import {
  activeRadiologistViewing,
  getMobileStudyData,
  getPatientData,
  getPriorStudyData,
  getSharedStudyData,
  getStudyData,
  getStudyExpirationStatus,
  getStudyDataForContextSwitch
} from "../../service/StudyViewerService";
import studyviewerContext from "./StudyviewerContext";
import { getStudyCommunicationData } from "../../service/CommunicationService";
import userContext from "../users/UserContext";
import { logAmplitudeEventWithUsernameAndRole } from "../../helpers/Amplitude";
import { userPreference } from "../../service/UserService";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import { hideTimer, showTimer, stopTimer, updateTimer } from "../../pages/StudyViewer/Components/Unassignment/StudyExpirationTimer";
import $ from "jquery";
import OrientationDetector from "../../components/OrientationDetector";

let initState = {
  viewport1Loading: false,
  viewport2Loading: false,
  viewport3Loading: false,
  viewport4Loading: false,
};

const StudyviewerState = (props) => {
  const { username, userId , contextSwitchUser, contextSwitchStudyviewer } = useContext(userContext);
  const [enableHeatmap, setEnableHeatmap] = useState(false);
  const [enableOutline, setEnableOutline] = useState(false);
  const [stackSize, setStackSize] = useState(0);
  const [progress, setProgress] = useState(0);
  const [progressComplete, setProgressComplete] = useState(true);
  const [dataGathered, setDataGathered] = useState(false);
  const [thumbnailLoaded, setThumbnailLoaded] = useState(false);
  const [savedKeyImages, setSavedKeyImages] = useState({});
  const [unsavedKeyImages, setUnsavedKeyImages] = useState({});
  const [keyImages, setKeyImages] = useState([]);
  const [priorStudyKeyImages, setPriorStudyKeyImages] = useState([]);
  const [studyResponseData, setStudyResponseData] = useState({});
  const [priorStudyResponseData, setPriorStudyResponseData] = useState({});
  const [studyModality, setStudyModality] = useState("");
  const [studyParentId, setParentStudyId] = useState();
  const [tempId, setTempId] = useState("");
  const [messageCount, setMessageCount] = useState(0);
  const [impressions, setImpressions] = useState({});
  const [isAccessAllowed, setIsAccessAllowed] = useState(true);
  const [notAllowedMessage, setNotAllowedMessage] = useState("");
  const [firmViewerId, setFirmViewerId] = useState(-1);
  const [autoGenerateReportData, setAutoGenerateReportData] = useState({
    maxAIEmergency: null,
    aiProcessed: null,
  });
  const [autoOpenReportPanel, setAutoOpenReportPanel] = useState(false);
  const [allLoadingComplete, setAllLoadingComplete] = useState(false);
  const [showToast, setShowToast] = useState({
    show: false,
    message: "",
    loading: false,
    state: "success",
  });
  const [assignmentData, setAssignementData] = useState({
    studyId: null,
    clientId: null,
    firmId: null,
    providerId: null,
    assignedRadiologist: null,
  });

  const [downloadStudyEnabled, setDownloadStudyEnabled] = useState(false);

  const [studyBoundingBox, setStudyBoundingBox] = useState([]);
  const [maskedBoundingBox, setMaskedBoundingBox] = useState([]);
  const [maskedBoundingBoxIndex, setMaskedBoundingBoxIndex] = useState(0);
  const [studyTextTool, setStudyTextTool] = useState([]);
  const [studyPredictedPathology, setStudyPredictedPathology] = useState([]);
  const [viewportLoading, setViewportLoading] = useState(initState);
  const [studyHistoryData, setStudyHistoryData] = useState([]);
  const [studyClinicalNotesData, setStudyClinicalNotesData] = useState("");
  const [reportSavedBy, setReportSavedBy] = useState(0);
  const [patientStudyData, setPatientStudyData] = useState({
    patientId: null,
    patientName: null,
    patientAge:null,
    patientSex:null,
    orderId:null,
    studyDescription:null,
    hospitalName:null,
    modality:null
  });
  const [weasisPatientDetails, setWeasisPatientDetails] = useState({
    patientId: null,
    patientName: null,
    patientAge:null,
    patientSex:null,
    orderId:null,
    modality:null, 
    studyDate : null, 
    studyIdDisplay : null
  }) 
  const [studyParentAssignmentData, setStudyParentAssignmentData] = useState(
    {}
  );
  const [isGenki, setIsGenki] = useState(false);
  const [meddreamFullUrl, setMeddreamFullUrl] = useState("");
  const [reportingDoctor, setReportingDoctor] = useState(null);
  const [parentChildReportsObj, setParentChildReportObj] = useState({});
  const [switchingToBasic, setSwitchingToBasic] = useState(false);
  const [aiProcessed, setAiProcessed] = useState(false);
  const [alreadyAddedBB, setAlreadyAddedBB] = useState(false);
  const [sharedDefaultViewer, setSharedDefaultViewer] = useState(-1);
  const [sharedAdvanceViewerURL, setSharedAdvanceViewerURL] = useState("");
  const [showStartAlertToast, setShowStartAlertToast] = useState(false);
  const [oneTimeShowAlertDone, setOneTimeShowAlertDone] = useState(false);
  const [showAttachment, setShowAttachment] = useState(false);
  const [showClinicalNotes, setShowClinicalNotes] = useState(false);
  const [forceReinferenceImageIds, setForceReinferenceImageIds] = useState([]);
  const [firstTimeLoadOnlyToast, setFirstTimeLoadOnlyToast] = useState(true);
  const [showShortcutModal, setShowShortcutModal] = useState(false);
    const [showPathologyOptions, setShowPathologyOptions] = useState(
    (isMobile || process.env.REACT_APP_VDC_PLATFORM=="true")? false : true
  );
  const [showTopBar, setShowTopBar] = useState(true);
  const [isLandscape, setIsLandscape] = useState(OrientationDetector());
  //   let patientResponseData = {};

  // const refreshReport = () => {
  //   getData(true);
  // }
  const [qcData, setQcData] = useState({
    clientId: null,
    firmId: null,
    radiologistId: null,
  });

  const [studyData, setStudyData] = useState({
    stacks: [],
    heatmapStacks: [],
    outlineStacks: [],
    originalStacks: [],
  });

  const [priorStudyData, setPriorStudyData] = useState([]);
  const [extReportRecieved, setExtReportRecieved] = useState(null);
  const [restrictionForVDC, setRestrictionForVDC] = useState(null);
  const [viewerOpacity, setViewerOpacity] = useState(1);
  const [sharedViewer, setSharedViewer] = useState(false);
  //const [enableUnassignmentService, setEnableUnassignmentService] = useState(null);
  const [reportDoneStatus, setreportDoneStatus] = useState(null);
  const [showStudyExpirationPopup, setShowStudyExpirationPopup] = useState(false);
  const [showStudyAlreadyExpiredPopup, setShowStudyAlreadyExpiredPopup] = useState(false);
  const [checkStudyExpired, setCheckStudyExpired] = useState(false);
  const [showSharedViewer, setShowSharedViewer] = useState(process.env.REACT_APP_VDC_PLATFORM === "true" ? false : true);
  const [advViewerUser, setAdvViewerUser] = useState(false);
  const [isOutlineEnabled, setIsOutlineEnabled] = useState(false);
  const [isHeatMapEnabled, setIsHeatMapEnabled] = useState(false);
  const [weasisViewerUser, setWeasisViewerUser] = useState(null);
  const [infinitViewerUser, setInifinitViewerUser] = useState(false);
  const [infinitViewerUrl, setinfinitViewerUrl] = useState(null);
  const [accessionNumber, setAccessionNumber] = useState(null);
  const [keyword, setKeyword] = useState(null);
  const [prefetchCount, setPrefetchCount] = useState(-1);
  const [twoMonitorEnabled, setTwoMonitorEnabled] = useState(false);
  const [basicWeasisUser, setBasicWeasisUser] = useState(null);
  const [isPriorsStudy, setIsPriorsStudy] = useState(false);
  const [isEnabledSlabThickness, setIsEnabledSlabThickness] = useState(false);
  const [s10User, setS10User] = useState(false);
  const [s10Url, setS10Url] = useState(null);
  const [advanceViewerURLIndex,setAdvanceViewerURLIndex] = useState(-1);
  const [advanceViewerSlotUUID,setAdvanceViewerSlotUUID] = useState(null);

  const [stackListSortedByImages, setStackListSortedByImages] = useState([]);

  const [isTypistWorkflowEnabled, setIsTypistWorkflowEnabled] = useState(false);
  const [showChats, setShowChats] = useState(false);
  const [typistShowHistory, setTypistShowHistory] = useState(false);
  const [cxrVersion, setCXRVersion] = useState(false);
  const [boneEnabled, setBoneEnabled] = useState(false);
  const [showFindingsHighlighted, setShowFindingsHighlighted] = useState(true);
  const [showProbablilityScores, setShowProbabilityScores] = useState(true);
  const [showAboveThresholdScore, setShowAboveThresholdScore] = useState(true);
  const [nonFrontalImages, setNonFrontalImages] = useState([]);

  const [hpDataList, setHpDataList] = useState({});
  const [hpLoading, setHpLoading] = useState(false);
  const [isHPApplied, setIsHpApplied] = useState(false);
  const [appliedHp, setAppliedHp] = useState({});
  const [hpPercentageMap, setHpPercentageMap] = useState(new Map());
  const [hpViewportMap, setHpViewportMap] = useState(new Map());
  const [hpNotFound, setHpNotFound] = useState(false);
  const [showSharedTopBar, setShowSharedTopBar] = useState(true);

  // const dicomBaseURL = API_BASE_URL + APIs.GETIMAGEDATA;
  const dicomBaseURL = API_BASE_URL.startsWith("https")
    ? API_BASE_URL.replace("https", "dicomweb") + APIs.GETIMAGEDATAWITHFILESIZE
    : API_BASE_URL.replace("http", "dicomweb") + APIs.GETIMAGEDATAWITHFILESIZE;
  // const dicomBaseURL = API_BASE_URL.startsWith("https")
  //   ? API_BASE_URL.replace("https", "web") + APIs.GETIMAGEDATA
  //   : API_BASE_URL.replace("http", "web") + APIs.GETIMAGEDATA;
  const imageBaseURL = API_BASE_URL.startsWith("https")
    ? API_BASE_URL.replace("https", "web") + APIs.GETIMAGEDATAWITHFILESIZE
    : API_BASE_URL.replace("http", "web") + APIs.GETIMAGEDATAWITHFILESIZE;

  const sharedDicomBaseURL = API_BASE_URL.startsWith("https")
    ? API_BASE_URL.replace("https", "dicomweb") + APIs.GETSHAREDIMAGEDATA
    : API_BASE_URL.replace("http", "dicomweb") + APIs.GETSHAREDIMAGEDATA;
  const sharedImageBaseURL = API_BASE_URL.startsWith("https")
    ? API_BASE_URL.replace("https", "web") + APIs.GETSHAREDIMAGEDATA
    : API_BASE_URL.replace("http", "web") + APIs.GETSHAREDIMAGEDATA;
  const kd = false;
  const isOriginal = false;
  const { t } = useTranslation();
  const [checkStudyExpirationStatus, setCheckStudyExpirationStatus] = useState(true);

const [maskImages, setMaskImages] = useState({});
  const getSlotAdvanceViewerUrl = (advViewerUrl) => {
    // Generate a random 5-letter UUID
    const generateUUID = () => Math.random().toString(36).substring(2, 7).toUpperCase();
  
    // Get or initialize slots with objects
    let advViewerSlots = JSON.parse(localStorage.getItem("advViewerSlots")) || Array(10).fill({ available: 0, uuid: null });
  
    const getNextAvailable = () => advViewerSlots.findIndex(slot => slot.available === 0);
  
    const num = getNextAvailable();
    if (num === -1) {
      console.error("No available slots in Advance Viewer.");
      return null;
    }
  
    const uuid = generateUUID();
    advViewerSlots[num] = { available: 1, uuid }; // Update the slot with availability and UUID
    localStorage.setItem("advViewerSlots", JSON.stringify(advViewerSlots));
  
    const advViewerSubDomain = process.env.REACT_APP_ADVANCE_VIEWER_SUB_DOMAIN;
    const newSubdomain = `${advViewerSubDomain}${num + 1}`;
    const updatedString = advViewerUrl.replace(advViewerSubDomain, newSubdomain);
    setAdvanceViewerSlotUUID(uuid);
    setAdvanceViewerURLIndex(num);
    console.log(`Slot ${num} assigned with UUID: ${uuid}`);
    return updatedString;
  };

  const fetchStudyData = async (studyId, checkForAdv) => {
    const advanceViewer = window.location.pathname.includes(
      "nonXrayAdvanceViewer"
    );
    let response = null;
    if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname && contextSwitchStudyviewer){
      response = await getStudyDataForContextSwitch();
    }else{

    
     response = await getStudyData(
      studyId,
      firmViewerId,
      process.env.REACT_APP_HYBRID_MODE,
      advanceViewer
    );
  }
    if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 451
    ) {
      setIsAccessAllowed(false);
      setNotAllowedMessage(response.data.message);
      return false;
    }
    if (response.status === 200) {
      // console.log(response.data.data);
      setStudyBoundingBox(
        response.data.data?.studyAnnotationMeasurement?.imageAnnotationMeasurements
      );
      setMaskedBoundingBox(response.data.data?.studyMaskingProfile?.imageMaskingProfiles || []);
      setStudyTextTool(
        response.data.data?.studyAnnotationMeasurement
          ?.imageToolAnnotationMeasurements
      );
      // setStudyBoundingBox(response.data.data.studyAnnotationMeasurement.imageAnnotationMeasurements);
      setParentStudyId(response.data.data.id);

      // console.log("Assingment data");
      // console.log(response.data.data.assignment);
      if (response.data.data.studyHistoryDocList != null) {
        setStudyHistoryData(response.data.data.studyHistoryDocList);
      }
      if (
        response.data.data.history != null ||
        response.data.data.history != undefined
      ) {
        setStudyClinicalNotesData(response.data.data.history);
      }
      setReportSavedBy(response.data.data.reportSavedBy);

      setAutoGenerateReportData(() => {
        const newItem = { ...autoGenerateReportData };
        newItem.maxAIEmergency = response.data.data.maxAIEmergency;
        newItem.aiProcessed = response.data.data.aiProcessed;
        return newItem;
      });

      setAssignementData(() => {
        const newItem = { ...assignmentData };
        newItem.clientId =
          response.data.data.clientId == null ? 0 : response.data.data.clientId;
        newItem.firmId = response.data.data.assignment.firmId;
        newItem.providerId = response.data.data.assignment.providerId;
        newItem.studyId = response.data.data.id;
        if (
          response.data.data.assignment.radiologist != undefined ||
          response.data.data.assignment.radiologist != null
        ) {
          newItem.assignedRadiologist =
            response.data.data.assignment.radiologist.username;
        } else {
          newItem.assignedRadiologist = null;
        }
        return newItem;
      });
      if (response.data?.data?.assignment != null) {
        setStudyParentAssignmentData(response.data.data.assignment);
      }
      setPatientStudyData(() => {
        const newItem = { ...patientStudyData };
        newItem.patientId = response.data.data.patientId;
        newItem.patientName = response.data.data.patientName;
        return newItem;
      });
      setShowFindingsHighlighted(response.data.data.assignment.firm.showFindings)
      setShowProbabilityScores(response.data.data.assignment.firm.showProbability)
      setWeasisPatientDetails(() =>{
        return getPatientDetailsData(response.data.data);
      });
      setQcData(() => {
        const newItem = { ...qcData };
        newItem.clientId = response.data.data.clientId;
        newItem.firmId = response.data.data.firmId;
        newItem.radiologistId = response.data.data.radiologistId;
        return newItem;
      });
      setIsGenki(
        response.data.data.genkyStudy && response.data.data.aiProcessed === 1
      );
      // setAdvViewerUser(response.data.data.nonXrayAdvanceViewer);
      if(process.env.REACT_APP_VDC_PLATFORM == "true"){
        setAdvViewerUser(response.data.data.advViewerUser);
      }else{
        setAdvViewerUser(response.data.data.nonXrayAdvanceViewer);
      }
      // setParentStudyId(response.data.data.id);
      setStudyModality(response.data.data.modality);
      setStudyPredictedPathology(response.data.data.studyPredictionList);
      // setModality(response.data.data.modality);
      setStudyResponseData(response.data.data);
      setAiProcessed(response.data.data.aiProcessed);
      if (checkForAdv) {
        generateStudyData(response.data.data);
      } else {
        generateStudyData(response.data.data, false);
        const url = getSlotAdvanceViewerUrl(response?.data?.data?.advanceViewerFullUrl);
        console.log("URL-----------"+url);
        if (url) {
          setMeddreamFullUrl(url);
        }else{
        setMeddreamFullUrl(response?.data?.data?.advanceViewerFullUrl);
        }
      }

      setDownloadStudyEnabled(response.data.data.allowDownloadStudy);
      setDataGathered(true);
      setAutoOpenReportPanel(!isLandscape? false : response.data.data.autoOpenReportPanel);
      setReportingDoctor(response.data.data.reportingDoctor);
      setExtReportRecieved(response.data.data.extReportReceived);
      setRestrictionForVDC(response.data.data.restrictionForVDC);
      setreportDoneStatus(response.data.data?.reportDoneStatus);
      //setEnableUnassignmentService(response?.data?.data?.enableUnassignmentService);
      checkStatusForExpiration(response?.data?.data?.id, response.data.data?.reportDoneStatus, response.data.data?.reportingDoctor);
      setIsTypistWorkflowEnabled(response.data.data.isTypistWorkflowEnabled);
      setTypistShowHistory(response.data.data.showHistory);
      setShowChats(response.data.data.showChats);
      setCXRVersion(response.data.data.cxrVersion);
      setBoneEnabled(response.data.data.boneEnabled);
      setShowAboveThresholdScore(response.data.data.showAboveThresholdScore);
      setWeasisViewerUser(response.data.data.weasisViewerUser);
      setInifinitViewerUser(response.data.data.infinitViewerUser);
      setinfinitViewerUrl(response.data.data.infinitViewerUrl);
      setPrefetchCount(response.data.data.prefetchCount);
      setBasicWeasisUser(response.data.data.basicWeasisUser);
      setAccessionNumber(response?.data?.data?.accessionNumber);
      setKeyword(response?.data?.data?.keyword);
      if(response?.data?.data?.priorsCount> 0 && response?.data?.data?.showPriors){
        setIsPriorsStudy(true);
      }

      setHpDataList(response.data.data.hpDtoList);
      if (!response.data.data.hpDtoList || response.data.data.hpDtoList.length == 0 || isMobile) {
        setHpNotFound(true);
      }
      setS10User(response?.data?.data?.s10User);
      setS10Url(response?.data?.data?.s10Url);
      setIsEnabledSlabThickness(response?.data?.data?.enabledSlabThickness);
      console.log("=========== enabledSlabThickness flag from API =", response?.data?.data?.enabledSlabThickness);
      return true;
    }
  };

  const getPatientDetailsData =(data)  =>{
    const newItem = {...weasisPatientDetails}
    newItem.patientId = data.patientId;
    newItem.patientName = data.patientName;
    newItem.patientAge = data.patientAge;
    newItem.patientSex = data.patientSex;
    newItem.orderId = data.orderId;
    newItem.modality = data.modality;
    newItem.studyDate  = data.studyDateDisplay;
    newItem.studyIdDisplay = data.id + "";
    newItem.studyDescription = data.studyDescription;
    return newItem;
  }

  useEffect(() => {
    if (
      checkStudyExpirationStatus &&
      reportDoneStatus != null &&
      reportingDoctor != null
    ) {
      const intervalId = setInterval(() => {
        checkStatusForExpiration(
          studyParentId,
          reportDoneStatus,
          reportingDoctor
        );
      }, 15000);
      return () => clearInterval(intervalId);
    }
  }, [
    reportDoneStatus,
    reportingDoctor,
    studyParentId,
    checkStudyExpirationStatus
  ]);

  useEffect(() => {
    checkStatusForExpiration(studyParentId, reportDoneStatus, reportingDoctor);  
  }, [checkStudyExpired]);

  const _shouldCallStudyStatusForExpiration = (reportDoneStatus, reportingDoctor) => {
   if(checkStudyExpirationStatus &&
      (reportDoneStatus == 0 || reportDoneStatus == 1) && reportingDoctor === username){
      return true;
    }
    return false;
  };

  const checkStatusForExpiration = async (studyId, reportDoneStatus, reportingDoctor) => {
    if (!_shouldCallStudyStatusForExpiration(reportDoneStatus, reportingDoctor)) {
      return;
    }

    const response = await getStudyExpirationStatus(studyId);
    console.log(response);
    if ((response.status = 200)) {
      var data = response.data.data;
      if (
        data?.unassignmentEnabled == true ||
        data?.unassignmentEnabled == "true"
      ) {
        displayTimerData(data);
        setShowStudyExpirationPopup(
          data.aboutToExpire == true || data.aboutToExpire == "true"
            ? true
            : false
        );
        setShowStudyAlreadyExpiredPopup(data.alreadyExpired == true || data.alreadyExpired == "true"
          ? true
          : false)
      } else {
        hideTimer();
        setShowStudyExpirationPopup(false); 
        stopTimer();
        setCheckStudyExpirationStatus(false);
      }
    }
  };

  
  const displayTimerData = (data) =>{
    updateTimer(data.timeLeftForExpiration, 0, setShowStudyExpirationPopup);
    showTimer();
  }

  const hideSeriesAndImageCount =() =>{
    const advanceViewer = window.location.pathname.includes("nonXrayAdvanceViewer");
    if(advanceViewer!= null && advanceViewer && weasisViewerUser != null && weasisViewerUser && infinitViewerUser != null && infinitViewerUser && weasisPatientDetails != null && weasisPatientDetails.modality != null &&  
      (weasisPatientDetails.modality == "CT" || weasisPatientDetails.modality == "MR")){
        return false;
    }
    return true;
  }

  const fetchPriorStudyData = async (studyId) => {
    const response = await getPriorStudyData(studyId, firmViewerId);
    if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 451
    ) {
      setIsAccessAllowed(false);
      setNotAllowedMessage(response.data.message);
    }
    if (response.status === 200) {
      // console.log(response.data.data.studyDtoList[0]);
      setStudyBoundingBox(
        response.data.data.studyDtoList[0].studyAnnotationMeasurement
          .imageAnnotationMeasurements
      );
      setStudyTextTool(
        response.data.data.studyDtoList[0].studyAnnotationMeasurement
          .imageToolAnnotationMeasurements
      );
      // setStudyBoundingBox(response.data.data.studyAnnotationMeasurement.imageAnnotationMeasurements);
      setParentStudyId(studyId);
      // console.log("Assingment data");
      // console.log(response.data.data.assignment);
      if (response.data.data.studyDtoList[0]?.studyHistoryDocList != null) {
        setStudyHistoryData(
          response.data.data.studyDtoList[0]?.studyHistoryDocList
        );
      }
      if (
        response.data.data.studyDtoList[0]?.history != null ||
        response.data.data.studyDtoList[0]?.history != undefined
      ) {
        setStudyClinicalNotesData(response.data.data.studyDtoList[0]?.history);
      }
      setReportSavedBy(response.data.data.studyDtoList[0].reportSavedBy);

      //TODO: Auto generated Report data

      setAssignementData(() => {
        const newItem = { ...assignmentData };
        newItem.clientId =
          response.data.data.studyDtoList[0].clientId == null
            ? 0
            : response.data.data.studyDtoList[0].clientId;
        newItem.firmId = response.data.data.studyDtoList[0].assignment?.firmId;
        newItem.providerId =
          response.data.data.studyDtoList[0].assignment?.providerId;
        newItem.studyId = response.data.data.studyDtoList[0].id;
        if (
          response.data.data.studyDtoList[0].assignment?.radiologist !=
            undefined ||
          response.data.data.studyDtoList[0].assignment?.radiologist != null
        ) {
          newItem.assignedRadiologist =
            response.data.data.studyDtoList[0].assignment?.radiologist.username;
        } else {
          newItem.assignedRadiologist = null;
        }
        return newItem;
      });
      setShowFindingsHighlighted(response.data.data.studyDtoList[0].assignment.firm.showFindings)
      setShowProbabilityScores(response.data.data.studyDtoList[0].assignment.firm.showProbability)
      setPatientStudyData(() => {
        const newItem = { ...patientStudyData };
        newItem.patientId = response.data.data.studyDtoList[0].patientId;
        newItem.patientName = response.data.data.studyDtoList[0].patientName;
        return newItem;
      });
      setQcData(() => {
        const newItem = { ...qcData };
        newItem.clientId = response.data.data.studyDtoList[0].clientId;
        newItem.firmId = response.data.data.studyDtoList[0].firmId;
        newItem.radiologistId =
          response.data.data.studyDtoList[0].radiologistId;
        return newItem;
      });
      setIsGenki(
        response.data.data.genkyStudy && response.data.data.aiProcessed === 1
      );
      // setParentStudyId(response.data.data.id);
      setStudyModality(response.data.data.studyDtoList[0].modality);
      setAiProcessed(response.data.data.studyDtoList[0].aiProcessed);
      setStudyPredictedPathology(
        response.data.data.studyDtoList[0].studyPredictionList
      );
      setCXRVersion(response.data.data.studyDtoList[0].cxrVersion);
      setBoneEnabled(response.data.data.studyDtoList[0].boneEnabled);
      setShowAboveThresholdScore(response.data.data.studyDtoList[0].showAboveThresholdScore);

      // setModality(response.data.data.modality);
      setPriorStudyResponseData(response.data.data);
      generatePriorStudyData(response.data.data.studyDtoList);
      setDownloadStudyEnabled(
        response.data.data.studyDtoList[0].allowDownloadStudy
      );
      setDataGathered(true);
      handleCreatingObjectForReports(response.data.data.studyDtoList);
      //TODO: setAutoOpenReportPanel
      setReportingDoctor(response.data.data.reportingDoctor);
      setAdvViewerUser(response.data.data.nonXrayAdvanceViewer);
      setPrefetchCount(response.data.data.prefetchCount);
      setTwoMonitorEnabled(response.data.data.twoMonitorEnabled);
      setHpDataList(response.data.data?.studyDtoList[0]?.hpDtoList);
      if (!response.data.data?.studyDtoList[0]?.hpDtoList || response.data.data?.studyDtoList[0]?.hpDtoList?.length == 0 || isMobile) {
        setHpNotFound(true);
      }
    }
  };

  const fetchSharedStudyData = async (shareToken, switchViewer, openViewer, isActiveData) => {
    const response = await getSharedStudyData(shareToken, isActiveData, switchViewer);

    if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 451 ||
      response.status === 404
    ) {
      setIsAccessAllowed(false);
      setNotAllowedMessage(response.data.message);
      return false;
    }
    if (response.status === 200) {
      setParentStudyId(response.data.data.id);

      setPatientStudyData(() => {
        const newItem = { ...patientStudyData };
        newItem.patientId = response.data.data.patientId;
        newItem.patientName = response.data.data.patientName;
        if (process.env.REACT_APP_VDC_PLATFORM === "true"){
          newItem.patientAge = response.data.data.patientAge;
          newItem.patientSex = response.data.data.patientSex;
          newItem.studyDescription = response.data.data.studyDescription;
          newItem.orderId = response.data.data.orderId;
          newItem.hospitalName = response.data.data.hospitalName;
          newItem.modality = response.data.data.modality;
        }
        return newItem;
      });


      if(process.env.REACT_APP_VDC_PLATFORM === "true"){
        setSharedAdvanceViewerURL(response.data.data.advanceViewerFullUrl);
      }

      if(process.env.REACT_APP_VDC_PLATFORM === "true" && (switchViewer == null || (switchViewer != null && switchViewer != "true")) && openViewer == null){
        setSharedDefaultViewer(response.data.data.defaultViewer);
      }else if(process.env.REACT_APP_VDC_PLATFORM === "true" && (switchViewer == null || (switchViewer != null && switchViewer != "true")) && openViewer == SHARED_VIEWER.BASIC){
        setSharedDefaultViewer(SHARED_VIEWER.BASIC);
      }else if(process.env.REACT_APP_VDC_PLATFORM === "true" && (switchViewer == null || (switchViewer != null && switchViewer != "true")) && (openViewer == SHARED_VIEWER.ADVANCE || openViewer != SHARED_VIEWER.BASIC)){
        setSharedDefaultViewer(SHARED_VIEWER.ADVANCE);
      }else if(process.env.REACT_APP_VDC_PLATFORM === "true"){
        setSharedDefaultViewer(-1);
      }

      setStudyModality(response.data.data.modality);
      setStudyResponseData(response.data.data);
      setAiProcessed(response.data.data.aiProcessed);
      generateStudyData(response.data.data, true);
      setDataGathered(true);
      setAdvViewerUser(response.data.data.advViewerUser);
      setHpNotFound(true);
      return true;
    }
  };

  const fetchMobileStudyData = async (studyId, checkForAdv) => {
    const advanceViewer = window.location.pathname.includes(
      "nonXrayAdvanceViewer"
    );
    const response = await getMobileStudyData(
      studyId,
      firmViewerId,
      process.env.REACT_APP_HYBRID_MODE,
      advanceViewer
    );
    if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 451 ||
      response.status === 404
    ) {
      setIsAccessAllowed(false);
      setNotAllowedMessage(response.data.message);
      return false;
    }
    if (response.status === 200) {
      setParentStudyId(response.data.data.id);

      if (process.env.REACT_APP_VDC_PLATFORM === "true") {
        if (response.data.data.defaultViewer === 0) {
          setSharedDefaultViewer(response.data.data.defaultViewer);
          setSharedAdvanceViewerURL(response.data.data.advanceViewerFullUrl);
          return;
        } else {
          setSharedDefaultViewer(response.data.data.defaultViewer);
          setSharedAdvanceViewerURL(response.data.data.advanceViewerFullUrl);
        }
      }

      setPatientStudyData(() => {
        const newItem = { ...patientStudyData };
        newItem.patientId = response.data.data.patientId;
        newItem.patientName = response.data.data.patientName;
        return newItem;
      });

      setStudyModality(response.data.data.modality);
      setStudyResponseData(response.data.data);
      setAiProcessed(response.data.data.aiProcessed);
      generateStudyData(response.data.data, true);
      setDataGathered(true);

      return true;
    }
  };

  const getMessageCount = async (studyParentId) => {
    let res = await getStudyCommunicationData(studyParentId);
    // console.log("--- Message count ---", res);
    if (res.status == 200 && res.data.result == "SUCCESS") {
      if (res.data.data.length > 0) {
        setMessageCount(res.data.data.length);
      }
    }
  };

  useEffect(() => {
    if (
      studyParentId != null &&
      studyParentId != undefined &&
      !sharedViewer &&
      !isMobile
    )
      getMessageCount(studyParentId);
  }, [studyParentId]);

  const handleActiveTabRadiologistViewing = async (active) => {
    try {
      const res = await activeRadiologistViewing(studyParentId, active);
    } catch (e) {}
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (
        reportingDoctor != null &&
        studyParentId != null &&
        reportingDoctor === username
      ) {
        // console.log(
        //   "--- Viewing viewer tab ----",
        //   document.visibilityState === "visible"
        // );
        if (document.visibilityState === "visible") {
          handleActiveTabRadiologistViewing(true);
        } else {
          if (!switchingToBasic) {
            handleActiveTabRadiologistViewing(false);
          }
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [reportingDoctor, studyParentId, switchingToBasic]);

  const generateStudyData = async (responseData, sharedData = false) => {
    let stacks = [];
    let heatmaps = [];
    let outlines = [];
    let originals = [];
    var keyImages = [];
    var nonFrontalImages = [];
    // responseData.studyDtoList.forEach((study) => {
    var study = responseData;
    var seriesIndex = 0;
    var length = study.seriesList.length;
    study.studyPredictionList.forEach((pred) => {
      if (
        pred.heatmapStorageKey != null &&
        pred.heatmapStorageKey.length != 0 &&
        pred.heatmap == true
      ) {
        length = length + 1;
      }
    });

    study.seriesList.forEach(function (series) {
      var originalStack = {
        imageIds: [],
      };
      var stack = {
        seriesDescription: series.seriesDescription,
        stackId: series.seriesNumber,
        seriesId: series.id,
        imageIds: [],
        keyImageIds: {},
        thumbnailImageIds: [],
        seriesIndex: seriesIndex++,
        currentImageIdIndex: 0,
        modality:
          series.modality != null ? series.modality.name : study.modality,
        length: length,
        studyId: study.id,
        studyIdDisplay: study.studyId,
        // modality: study.modality,
        studyDescription: study.studyDescription,
        studyDate: study.studyDateDisplay,
        uploadDate: study.uploadDateDisplay,
        isHeatmap: false,
        bodyPart: series.bodyPart,
        options: {
          visible: true,
          name: "ORIGINAL",
        },
        patientAge: study.patientAge,
        patientSex: study.patientSex,
        patientName: study.patientName,
        patientId: study.patientId,
        orderId: study.orderId,
        images: [],
      };
      var heatmapStack = {
        imageIds: [],
        currentImageIdIndex: 0,
        studyId: study.id,
        options: {
          opacity: 0.5,
          visible: false,
          name: "HEATMAP",
        },
      };
      var outlineStack = {
        imageIds: [],
        studyId: study.id,
        currentImageIdIndex: 0,
        options: {
          opacity: 0.5,
          visible: false,
          name: "OUTLINE",
        },
      };
      // Populate imageIds array with the imageIds from each
      // series
      // For series with frame information, get the image url's by
      // requesting each frame
      series.imageList.forEach(function (image) {
        var imageStorageKey = "";
        var originalImageStorageKey = image.imageStorageKey;
        var heatmapMaskStorageKey = image.heatmapStorageKey;
        var outlineMaskStorageKey = image.outlineStorageKey;
        var thumbnailStorageKey = image.thumbnailStorageKey;
        var imageId = image.id;

        // console.log(study.genkyStudy)
        // console.log(study.aiProcessed === 1)
        if (study.genkyStudy && study.aiProcessed === 1) {
          if (sharedData) {
            thumbnailStorageKey = sharedImageBaseURL  + thumbnailStorageKey;
            imageStorageKey = sharedImageBaseURL  + image.thumbnailStorageKey;
          } else {
            thumbnailStorageKey = imageBaseURL + imageId + "/" + thumbnailStorageKey;
            imageStorageKey = imageBaseURL + imageId + "/" + image.thumbnailStorageKey;
          }
        } else if (stack.modality === "SR") {
          if (sharedData) {
            thumbnailStorageKey =
              API_BASE_URL + APIs.GETSHAREDIMAGEDATA  + thumbnailStorageKey;
            imageStorageKey =
              API_BASE_URL +
              APIs.GETSHAREDIMAGEDATA  +
              image.thumbnailStorageKey;
          } else {
            thumbnailStorageKey =
              API_BASE_URL + APIs.GETIMAGEDATAWITHFILESIZE + imageId + "/" + thumbnailStorageKey;
            imageStorageKey =
              API_BASE_URL + APIs.GETIMAGEDATAWITHFILESIZE + imageId + "/" + image.thumbnailStorageKey;
          }
        } else {
          if (sharedData) {
            thumbnailStorageKey = sharedDicomBaseURL + thumbnailStorageKey;
            imageStorageKey = sharedDicomBaseURL + image.thumbnailStorageKey;
          } else {
            thumbnailStorageKey = dicomBaseURL + imageId + "/" + thumbnailStorageKey;
            imageStorageKey = dicomBaseURL + imageId + "/" + image.thumbnailStorageKey;
          }
        }
        if (originalImageStorageKey != null) {
          if (sharedData) {
            originalImageStorageKey =
              sharedDicomBaseURL + originalImageStorageKey;
          } else {
            originalImageStorageKey = dicomBaseURL + imageId + "/" + originalImageStorageKey;
          }
        }
        if (heatmapMaskStorageKey != null) {
          if (sharedData) {
            heatmapMaskStorageKey = sharedImageBaseURL + heatmapMaskStorageKey;
          } else {
            heatmapMaskStorageKey = imageBaseURL + imageId + "/" + heatmapMaskStorageKey;
          }
        }

        if (outlineMaskStorageKey != null) {
          if (sharedData) {
            outlineMaskStorageKey = sharedImageBaseURL + outlineMaskStorageKey;
          } else {
            outlineMaskStorageKey = imageBaseURL + imageId + "/" + outlineMaskStorageKey;
          }
        }

        if (image.keyImageTitle != null) {
          let keyImage = {
            imageUrl: imageStorageKey,
            keyImageTitle: image.keyImageTitle,
            state: "SAVED",
          };
          keyImages.push(keyImage);
        }

        if (image.isNonFrontal) {
          nonFrontalImages.push({
            imageId: image.id,
            imageUrl: imageStorageKey,
            isSentForForceReinference: image.isSentForForceReinference,
          });
        }
        stack.images.push(image);
        stack.imageIds.push(imageStorageKey);
        stack.thumbnailImageIds.push(thumbnailStorageKey);
        heatmapStack.imageIds.push(heatmapMaskStorageKey);
        outlineStack.imageIds.push(outlineMaskStorageKey);
        originalStack.imageIds.push(originalImageStorageKey);
      });
      // Add the series stack to the stacks array

      stacks.push(stack);
      heatmaps.push(heatmapStack);
      outlines.push(outlineStack);
      originals.push(originalStack);
    });
    // });

    setStudyData({
      ...studyData,
      studyDateDisplay: study.studyDateDisplay,
      uploadDateDisplay: study.uploadDateDisplay,
      stacks: stacks,
      heatmapStacks: heatmaps,
      outlineStacks: outlines,
      originalStacks: originals,
      keyImages: keyImages,
    });
    setStackSize(stacks.length);

    setSavedKeyImages(keyImages);
    setKeyImages(keyImages);
    setNonFrontalImages(nonFrontalImages);

    // console.log(savedKeyImages);
  };

  useEffect(() => {
    // console.log(" -------?-- PATIENT DATA --------- ");
    console.log("StudyData", studyData);
    const sortedIndexLengthMap = studyData.stacks
      .map((stack, index) => ({ index, length: stack.thumbnailImageIds.length }))  // Map index and imageIds length
      .sort((a, b) => a.length - b.length);  
    
    setStackListSortedByImages(sortedIndexLengthMap);
  },[studyData]);

  
  useEffect(() => {
    if(priorStudyData && priorStudyData.length>0){
     const sortedIndexLengthMap = priorStudyData[0].stacks
        .map((stack, index) => ({ index, length: stack.thumbnailImageIds.length }))  // Map index and imageIds length
        .sort((a, b) => a.length - b.length);  
      
      setStackListSortedByImages(sortedIndexLengthMap);
    }
  },[priorStudyData]);

  // useEffect(() =>{
  //   console.log(" -------- STACK DATA IN ORDER --------- ");
  //   console.log(stackListSortedByImages);
  // },[stackListSortedByImages]);

  const removeTags = (str) => {
    if (str === null || str === "") return false;
    else str = str.toString();
    return str.replace(/(<([^>]+)>|&nbsp;|\r)/gi, "");
    // return str.replace(/<.*?>/, "");
  };

  useEffect(() => {
    if (
      (studyHistoryData?.length > 0 ||
        studyClinicalNotesData.length > 0 ||
        messageCount > 0) &&
        firstTimeLoadOnlyToast &&
      (allLoadingComplete ||
        window.location.href.includes("nonXrayAdvanceViewer")) &&
      !isMobile
    ) {
      setShowStartAlertToast(true);
      setFirstTimeLoadOnlyToast(false);
    }
  }, [
    studyHistoryData,
    studyClinicalNotesData,
    messageCount,
    allLoadingComplete,
  ]);

  const handleCreatingObjectForReports = async (responseData) => {
    let allReportsObj = {};
    responseData.map((study, index) => {
      if (allReportsObj.id == undefined) {
        allReportsObj[study.id] = study;
      }
    });
    setParentChildReportObj(allReportsObj);
  };

  const generatePriorStudyData = async (responseData) => {
    let stackSize = 0;
    let priorStudies = [];
    let stacks = [];
    let heatmaps = [];
    let outlines = [];
    let originals = [];
    var keyImages = [];
    let tempImpressions = {};
    var nonFrontalImages = [];
    // responseData.studyDtoList.forEach((study) => {
    var seriesIndex = 0;
    responseData.map((study, index) => {
      var length = study.seriesList.length;
      var impression = [];
      var impressionText = "";
      study.studyReportList.map((studyReport, index) => {
        if (studyReport.finalReport) {
          var impressionWithTagsIndex =
            studyReport.finalReport.search("IMPRESSION");
          const impressionWithTags = studyReport.finalReport.slice(
            impressionWithTagsIndex,
            studyReport.finalReport.length
          );

          const finalImpressionIndex = impressionWithTags.search("<div>");
          const finalIMpression = impressionWithTags.slice(
            finalImpressionIndex,
            impressionWithTags.length
          );
          if (finalIMpression !== ">") {
            impression.push(finalIMpression);
          }
          // console.log(
          //   studyReport.finalReport.slice(
          //     impressionWithTags,
          //     studyReport.finalReport.length
          //   )
          // );
          // var reportImpression = removeTags(
          //   studyReport.finalReport.slice(
          //     impressionWithTags,
          //     studyReport.finalReport.length
          //   )
          // );
          // if (reportImpression !== ">" && reportImpression.length > 11) {
          //   impression.push(reportImpression.slice(10));
          // }
        }
      });

      impression.map((imp, index) => {
        let newImpression = imp.split("\n");
        newImpression.map((ni, index) => {
          impressionText += `${ni.startsWith(":") ? ni.slice(1) : ni}`;
        });
      });

      if (impression.length === 0) {
        if (study.reportDoneStatus === REPORTDONESTATUS.REPORTED) {
          impressionText += t("string-literals.impression-not-available");
        } else {
          impressionText += t("string-literals.impression-unreported");
        }
      }

      tempImpressions = {
        ...tempImpressions,
        ["study_" + study.id]: {
          studyDate: study.studyDateDisplay,
          uploadDate: study.uploadDateDisplay,
          impressionText,
          studyId: study.id,
        },
      };

      study.studyPredictionList.forEach((pred) => {
        if (
          pred.heatmapStorageKey != null &&
          pred.heatmapStorageKey.length != 0 &&
          pred.heatmap == true
        ) {
          length = length + 1;
        }
      });
      study.seriesList.forEach(function (series) {
        var originalStack = {
          studyId: study.id,
          imageIds: [],
        };
        var stack = {
          seriesDescription: series.seriesDescription,
          stackId: series.seriesNumber,
          seriesId: series.id,
          imageIds: [],
          keyImageIds: {},
          thumbnailImageIds: [],
          seriesIndex: seriesIndex++,
          currentImageIdIndex: 0,
          modality:
            series.modality != null ? series.modality.name : study.modality,
          length: length,
          studyId: study.id,
          studyIdDisplay: study.studyId,
          // modality: study.modality,
          studyDescription: study.studyDescription,
          studyDate: study.studyDateDisplay,
          uploadDate: study.uploadDateDisplay,
          isHeatmap: false,
          bodyPart: series.bodyPart,
          options: {
            visible: true,
            name: "ORIGINAL",
          },
          patientAge: study.patientAge,
          patientSex: study.patientSex,
          patientName: study.patientName,
          patientId: study.patientId,
          images: [],
        };
        var heatmapStack = {
          imageIds: [],
          currentImageIdIndex: 0,
          studyId: study.id,
          options: {
            opacity: 0.5,
            visible: false,
            name: "HEATMAP",
          },
          modality: stack.modality,
        };
        var outlineStack = {
          imageIds: [],
          studyId: study.id,
          currentImageIdIndex: 0,
          options: {
            opacity: 0.5,
            visible: false,
            name: "OUTLINE",
          },
          modality: stack.modality,
        };
        // Populate imageIds array with the imageIds from each
        // series
        // For series with frame information, get the image url's by
        // requesting each frame
        series.imageList.forEach(function (image) {
          var imageStorageKey = "";
          var originalImageStorageKey = image.imageStorageKey;
          var heatmapMaskStorageKey = image.heatmapStorageKey;
          var outlineMaskStorageKey = image.outlineStorageKey;
          var thumbnailStorageKey = image.thumbnailStorageKey;
          var imageId = image.id;
          // console.log(study.genkyStudy)
          // console.log(study.aiProcessed === 1)
          if (study.genkyStudy && study.aiProcessed === 1) {
            thumbnailStorageKey = imageBaseURL + imageId + "/"  + thumbnailStorageKey;
            imageStorageKey = imageBaseURL + imageId + "/"  + image.thumbnailStorageKey;
          } else if (stack.modality === "SR") {
            thumbnailStorageKey =
              API_BASE_URL + APIs.GETIMAGEDATA + thumbnailStorageKey;
            imageStorageKey =
              API_BASE_URL + APIs.GETIMAGEDATA + image.thumbnailStorageKey;
          } else {
            thumbnailStorageKey = dicomBaseURL + imageId + "/"  + thumbnailStorageKey;
            imageStorageKey = dicomBaseURL + imageId + "/"  + image.thumbnailStorageKey;
          }
          if (originalImageStorageKey != null) {
            originalImageStorageKey = dicomBaseURL + imageId + "/"  + originalImageStorageKey;
          }
          if (heatmapMaskStorageKey != null)
            heatmapMaskStorageKey = imageBaseURL + imageId + "/"  + heatmapMaskStorageKey;

          if (outlineMaskStorageKey != null)
            outlineMaskStorageKey = imageBaseURL + imageId + "/"  + outlineMaskStorageKey;

          if (image.keyImageTitle != null) {
            let keyImage = {
              imageUrl: imageStorageKey,
              keyImageTitle: image.keyImageTitle,
              state: "SAVED",
            };
            keyImages.push(keyImage);
          }
          if (image.isNonFrontal) {
            nonFrontalImages.push({
              imageId: image.id,
              imageUrl: imageStorageKey,
              isSentForForceReinference: image.isSentForForceReinference,
            });
          }

          stack.images.push(image);
          stack.imageIds.push(imageStorageKey);
          stack.thumbnailImageIds.push(thumbnailStorageKey);
          heatmapStack.imageIds.push(heatmapMaskStorageKey);
          outlineStack.imageIds.push(outlineMaskStorageKey);
          originalStack.imageIds.push(originalImageStorageKey);
        });
        // Add the series stack to the stacks array

        stacks.push(stack);
        heatmaps.push(heatmapStack);
        outlines.push(outlineStack);
        originals.push(originalStack);
      });
      priorStudies.push({
        studyId: study.id,
        studyDateDisplay: study.studyDateDisplay,
        uploadDateDisplay: study.uploadDateDisplay,
        stacks,
        heatmapStacks: heatmaps,
        outlineStacks: outlines,
        originalStacks: originals,
        keyImages,
      });
      if (index === 0) {
        setSavedKeyImages(keyImages);
        setKeyImages(keyImages);
        setNonFrontalImages(nonFrontalImages);
        keyImages = [];
        nonFrontalImages = [];
      } else {
        setPriorStudyKeyImages(keyImages);
      }
      stackSize++;
      stacks = [];
      heatmaps = [];
      outlines = [];
      originals = [];
    });

    // setStudyData({
    //   ...studyData,
    //   stacks: stacks,
    //   heatmapStacks: heatmaps,
    //   outlineStacks: outlines,
    //   originalStacks: originals,
    //   keyImages: keyImages,
    // });
    setStackSize(stackSize);
    setPriorStudyData(priorStudies);
    setImpressions(tempImpressions);
    // setStackSize(stacks.length);

    console.log(priorStudies);
  };

  const checkForMaskingAnnotation= (annotationId)=>{
    let isMarked = false
    for (const [imageId, imageData] of Object.entries(maskImages)) {
      const annotations = imageData.maskAnnotationData || [];
      if (annotations.some(a => a.annotationUID === annotationId)) {
        console.log(imageId, annotations);
        return {imageId, ...imageData}; // optionally include imageId
      }
  }
 
    return null;
  }

  return (
    <studyviewerContext.Provider
      value={{
        fetchStudyData,
        studyData,
        setStudyData,
        studyResponseData,
        studyModality,
        studyParentId,
        generateStudyData,
        showToast,
        assignmentData,
        setShowToast,
        studyBoundingBox,
        studyTextTool,
        setStudyBoundingBox,
        studyPredictedPathology,
        viewportLoading,
        setViewportLoading,
        savedKeyImages,
        setSavedKeyImages,
        setUnsavedKeyImages,
        unsavedKeyImages,
        keyImages,
        setKeyImages,
        qcData,
        studyHistoryData,
        studyClinicalNotesData,
        messageCount,
        setMessageCount,
        progress,
        setProgress,
        progressComplete,
        setProgressComplete,
        stackSize,
        setStackSize,
        dataGathered,
        setDataGathered,
        thumbnailLoaded,
        setThumbnailLoaded,
        generatePriorStudyData,
        fetchPriorStudyData,
        priorStudyResponseData,
        setPriorStudyResponseData,
        priorStudyData,
        patientStudyData,
        impressions,
        downloadStudyEnabled,
        isAccessAllowed,
        notAllowedMessage,
        enableHeatmap,
        setEnableHeatmap,
        enableOutline,
        setEnableOutline,
        firmViewerId,
        reportDoneStatus,
        reportingDoctor,
        setFirmViewerId,
        reportSavedBy,
        setReportSavedBy,
        isGenki,
        autoGenerateReportData,
        setAutoGenerateReportData,
        autoOpenReportPanel,
        meddreamFullUrl,
        setMeddreamFullUrl,
        advanceViewerURLIndex,
        advanceViewerSlotUUID,
        priorStudyKeyImages,
        setPriorStudyKeyImages,
        parentChildReportsObj,
        setSwitchingToBasic,
        extReportRecieved,
        restrictionForVDC,
        getMessageCount,
        studyParentAssignmentData,
        aiProcessed,
        viewerOpacity,
        setViewerOpacity,
        alreadyAddedBB,
        setAlreadyAddedBB,
        fetchSharedStudyData,
        sharedViewer,
        setSharedViewer,
        sharedDefaultViewer,
        setSharedDefaultViewer,
        sharedAdvanceViewerURL,
        setSharedAdvanceViewerURL,
        fetchMobileStudyData,
        showStartAlertToast,
        setShowStartAlertToast,
        setOneTimeShowAlertDone,
        showAttachment,
        setShowAttachment,
        showClinicalNotes,
        setShowClinicalNotes,
        setAllLoadingComplete,
        showStudyExpirationPopup,
        setShowStudyExpirationPopup,
        showStudyAlreadyExpiredPopup,
        setShowStudyAlreadyExpiredPopup,
        checkStudyExpired, setCheckStudyExpired,
        setIsTypistWorkflowEnabled,isTypistWorkflowEnabled,
        setShowChats,showChats,
        setTypistShowHistory,typistShowHistory,
        cxrVersion,boneEnabled,
        advViewerUser, setAdvViewerUser,
        nonFrontalImages,
        forceReinferenceImageIds, 
        setForceReinferenceImageIds,
        advViewerUser, setAdvViewerUser,
        showSharedViewer, setShowSharedViewer,
        isOutlineEnabled,
        setIsOutlineEnabled,
        isHeatMapEnabled,
        setIsHeatMapEnabled,
        showShortcutModal, setShowShortcutModal,
        weasisViewerUser, setWeasisViewerUser,
        infinitViewerUser, setInifinitViewerUser,
        infinitViewerUrl, setinfinitViewerUrl,
        accessionNumber, setAccessionNumber,
        keyword,setKeyword,
        weasisPatientDetails, setWeasisPatientDetails, 
        hideSeriesAndImageCount,
        isPriorsStudy,
        showFindingsHighlighted,
        showAboveThresholdScore,
        showProbablilityScores,
        prefetchCount,
        stackListSortedByImages,
        basicWeasisUser,
        setBasicWeasisUser,
        hpDataList, hpLoading, setHpLoading,
        s10User,
        s10Url,
        isLandscape,
        showPathologyOptions, setShowPathologyOptions,
        showTopBar, setShowTopBar,
        showSharedTopBar, setShowSharedTopBar,
        isHPApplied, setIsHpApplied,
        appliedHp, setAppliedHp,
        hpPercentageMap, setHpPercentageMap,
        hpViewportMap, setHpViewportMap,
        hpNotFound, setHpNotFound,
        twoMonitorEnabled, setTwoMonitorEnabled,
        isEnabledSlabThickness, 
        maskedBoundingBox, setMaskedBoundingBox, maskedBoundingBoxIndex, setMaskedBoundingBoxIndex,
        maskImages, setMaskImages,
        checkForMaskingAnnotation
      }}
    >
      {props.children}
    </studyviewerContext.Provider>
  );
};

export default StudyviewerState;

